<template>
  <div>
    <!-- 标题 -->
    <div class="ebs-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/elasticBlockStoreMonitor">{{
          $t("alarms.disk.disk")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="ebs-top">
      <Row :gutter="16" v-show="isAWS">
        <Col span="7">
          <DatePicker
            confirm
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择时间区间"
            style="width: 350px"
            :options="dataOptions"
            v-model="timeRegion"
            @on-change="handleChangeTime"
            @on-ok="changeTimeType"
            @on-clear="handleClear"
          ></DatePicker>
        </Col>
        <Col span="5">
          <Select v-model="cycle" filterable @on-change="changeCycle()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? awsList
          : []"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import utils from "../../../../utils/utils.js";
export default {
  name: "EBS",
  data() {
    return {
      dataOptions: {
        disabledDate(value) {
          // 把当前时间的前 14天 后 14天之外的都禁用
          const startTime = new Date();
          const endTime = new Date();
          startTime.setDate(new Date().getDate() - 14);
          endTime.setDate(new Date().getDate() + 14);
          return !(value >= startTime && value <= endTime);
        }
      },
      startDate: "",
      endDate: "",
      timeRegion: [],
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // aws折线图
      awsList: [
        {
          id: "volumeTotalReadWriteTimes",
          title: this.$t(
            "alarms.disk.line.TheTotalNumberOfSecondsSpentInReadAndWriteOperationsSeconds"
          )
        },
        {
          id: "volumeReadWriteOps",
          title: this.$t("alarms.disk.line.ReadAndWriteThroughputOpss")
        },
        {
          id: "volumeReadWriteBytes",
          title: this.$t("alarms.disk.line.ReadAndWriteBandwidthBytes")
        }
      ],
      isAWS: false,
      isAzure: false,
      isAliyun: false,
      isGCP: false,
      timeType: 0,
      timeList: [],
      cycle: 300,
      cycleList: [
        {
          name: this.$t("alarms.common.fiveMinutes"),
          value: 5 * 60
        },
        {
          name: this.$t("alarms.common.fifteenMinutes"),
          value: 15 * 60
        },
        {
          name: this.$t("alarms.common.oneHour"),
          value: 1 * 60 * 60
        },
        {
          name: this.$t("alarms.common.sixHour"),
          value: 6 * 60 * 60
        },
        {
          name: this.$t("alarms.common.oneDay"),
          value: 24 * 60 * 60
        }
      ],
      // echarts实例
      chartVolumeTotalReadWriteTimes: "",
      chartVolumeReadWriteOps: "",
      chartVolumeReadWriteBytes: "",
      diskReadWriteIOPSOption: {}, //azure
      diskReadIOPSOption: {},
      diskWriteIOPSOption: {},
      diskSpaceUtilizationOption: {},
      spaceUsageOption: {},
      inodeUtilizationOption: {},
      diskReadAndWriteBPSOption: {},
      diskReadAndWriteRequestCountOption: {}, //阿里云
      volumeTotalReadWriteTimesOption: {},
      volumeReadWriteOpsOption: {},
      volumeReadWriteBytesOption: {},
      burstBalancesOption: {},
      volumeQueueLengthsOption: {},
      volumeIdleTimesOption: {}, //aws
      // Aliyun数组
      diskReadIOPSAliyun: [],
      diskWriteIOPSAliyun: [],
      diskSpaceUtilizationAliyun: [],
      spaceUsageAliyun: [],
      inodeUtilizationAliyun: [],
      diskReadAndWriteBPSAliyun: [],
      diskReadBPS: [],
      diskWriteBPS: [],
      diskReadAndWriteRequestCountAliyun: [],
      diskReadRequestCount: [],
      diskWriteRequestCount: [],
      // Azure数组
      diskWriteIOPSAzure: [],
      diskReadIOPSAzure: [],
      xaxisData: [],
      // Aws数组
      diskReadOps: [],
      diskWriteOps: [],
      burstBalance: [],
      volumeIdleTime: [],
      volumeQueueLength: [],
      diskReadBytes: [],
      volumeTotalReadTime: [],
      volumeTotalWriteTime: [],
      diskWriteBytes: [],
      xaxisDataAWS: [],
      // GCP数组
      gcpDiskBytesUsed: [],
      gcpDiskIOTime: [],
      gcpDiskOperationCount: [],
      gcpDiskBytesUsedOption: {},
      gcpDiskIOTimeOption: {},
      gcpDiskOperationCountOption: {},
      gcpXaxisDataTimeLine: [],
      chartGcpDiskBytesUsed: "",
      chartGcpDiskIOTime: "",
      chartGcpDiskOperationCount: "",

      volumeTotalReadTimeByAi: [],
      volumeTotalWriteTimeByAi: [],
      diskReadOpsByAi: [],
      diskWriteOpsByAi: [],
      diskReadBytesByAi: [],
      diskWriteBytesByAi: []
    };
  },
  mounted: function() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chartVolumeTotalReadWriteTimes.resize();
        self.chartVolumeReadWriteOps.resize();
        self.chartVolumeReadWriteBytes.resize();
      });
      this.initAWS();
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      var myDate = new Date();
      let timestep = myDate.setHours(myDate.getHours(), 0, 0, 0); // 返回时间戳
      let timestep1 = myDate.setHours(myDate.getHours() + 1, 0, 0, 0); // 返回时间戳
      this.timeRegion[0] = this.startDate = utils.methods.formatDate(timestep);
      this.timeRegion[1] = this.endDate = utils.methods.formatDate(timestep1);
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function(item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          // azure
          if (item.id == "diskReadWriteIOPS") {
            var optionFll = this.diskReadWriteIOPSOption;
          }
          // aws
          else if (item.id == "volumeTotalReadWriteTimes") {
            var optionFll = this.volumeTotalReadWriteTimesOption;
          } else if (item.id == "volumeReadWriteOps") {
            var optionFll = this.volumeReadWriteOpsOption;
          } else if (item.id == "volumeReadWriteBytes") {
            var optionFll = this.volumeReadWriteBytesOption;
          } else if (item.id == "diskWriteIOPS") {
            var optionFll = this.diskWriteIOPSOption;
          } else if (item.id == "diskSpaceUtilization") {
            var optionFll = this.diskSpaceUtilizationOption;
          } else if (item.id == "spaceUsage") {
            var optionFll = this.spaceUsageOption;
          } else if (item.id == "inodeUtilization") {
            var optionFll = this.inodeUtilizationOption;
          } else if (item.id == "diskReadAndWriteBPS") {
            var optionFll = this.diskReadAndWriteBPSOption;
          } else if (item.id == "diskReadAndWriteRequestCount") {
            var optionFll = this.diskReadAndWriteRequestCountOption;
          }
          fullChart.setOption(optionFll);
          window.addEventListener("resize", function() {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function() {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then(res => {
          this.timeList = res.data;
        });
    },
    handleChangeTime(date) {
      if (!!date) {
        this.timeRegion = date;
        this.startDate = date[0];
        this.endDate = date[1];
      } else {
        this.timeRegion = [];
        this.startDate = "";
        this.endDate = "";
      }
    },
    // 切换时间
    changeTimeType: function() {
      this.initAWS();
    },
    // 切换周期
    changeCycle: function() {
      this.initAWS();
    },
    handleClear() {
      this.timeRegion = [];
      this.startDate = "";
      this.endDate = "";
      this.initAWS();
    },
    /******************所有折线图********************************/
    initAWS: function() {
      if (!this.startDate || !this.endDate) {
        this.$Message.error("请选择日期区间");
        return false;
      }
      this.chartVolumeTotalReadWriteTimesLine();
      this.chartVolumeReadWriteOpsLine();
      this.chartVolumeReadWriteBytesLine();
    },
    /*************AWS折线图*****************************/
    // 读取和写入操作耗费的总秒数（秒）
    chartVolumeTotalReadWriteTimesLine: function() {
      this.chartVolumeTotalReadWriteTimes = this.$echarts.init(
        document.getElementById("volumeTotalReadWriteTimes")
      );
      this.chartVolumeTotalReadWriteTimes.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 11,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["VolumeTotalReadTime", "VolumeTotalWriteTime"]
        })
        .then(res => {
          this.chartVolumeTotalReadWriteTimes.hideLoading();
          this.volumeTotalReadTime = res.data.volumeTotalReadTime;
          this.volumeTotalWriteTime = res.data.volumeTotalWriteTime;
          this.volumeTotalReadTimeByAi = res.data.volumeTotalReadTimeByAi;
          this.volumeTotalWriteTimeByAi = res.data.volumeTotalWriteTimeByAi;
          this.xaxisDataAWS = res.data.xaxisData;
          if (this.xaxisDataAWS[0] == null) {
            this.xaxisDataAWS = [];
          }
          this.volumeTotalReadWriteTimesOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 读取操作耗费的总秒数 写入操作耗费的总秒数
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t(
                  "alarms.disk.line.TheTotalNumberOfSecondsSpentInTheReadOperation"
                ),
                this.$t(
                  "alarms.disk.line.TheTotalNumberOfSecondsSpentInWriteOperations"
                ),
                this.$t(
                  "alarms.disk.line.TheTotalNumberOfSecondsSpentInTheReadOperationForecast"
                ),
                this.$t(
                  "alarms.disk.line.TheTotalNumberOfSecondsSpentInWriteOperationsForecast"
                )
              ]
            },
            series: [
              {
                name: this.$t(
                  "alarms.disk.line.TheTotalNumberOfSecondsSpentInTheReadOperation"
                ),
                type: "line",
                data: this.volumeTotalReadTime,
                itemStyle: {
                  normal: {
                    color: "#61a0a8",
                    lineStyle: {
                      color: "#61a0a8"
                    }
                  }
                }
              },
              {
                name: this.$t(
                  "alarms.disk.line.TheTotalNumberOfSecondsSpentInWriteOperations"
                ),
                type: "line",
                data: this.volumeTotalWriteTime,
                itemStyle: {
                  normal: {
                    color: "#FF9B40",
                    lineStyle: {
                      color: "#FF9B40"
                    }
                  }
                }
              },
              {
                name: this.$t(
                  "alarms.disk.line.TheTotalNumberOfSecondsSpentInTheReadOperationForecast"
                ),
                type: "line",
                data: this.volumeTotalReadTimeByAi,
                itemStyle: {
                  normal: {
                    color: "#DEB887",
                    lineStyle: {
                      color: "#DEB887"
                    }
                  }
                }
              },
              {
                name: this.$t(
                  "alarms.disk.line.TheTotalNumberOfSecondsSpentInWriteOperationsForecast"
                ),
                type: "line",
                data: this.volumeTotalWriteTimeByAi,
                itemStyle: {
                  normal: {
                    color: "#0000FF",
                    lineStyle: {
                      color: "#0000FF"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisDataAWS.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };

          this.chartVolumeTotalReadWriteTimes.setOption(
            this.volumeTotalReadWriteTimesOption,
            true
          );
        })
        .catch(err => {
          this.chartVolumeTotalReadWriteTimes.hideLoading();
        });
    },
    // 读写吞吐量（Ops/s）
    chartVolumeReadWriteOpsLine: function() {
      this.chartVolumeReadWriteOps = this.$echarts.init(
        document.getElementById("volumeReadWriteOps")
      );
      this.chartVolumeReadWriteOps.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 11,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["DiskReadOps", "DiskWriteOps"]
        })
        .then(res => {
          this.chartVolumeReadWriteOps.hideLoading();
          this.diskReadOps = res.data.diskReadOps;
          this.diskWriteOps = res.data.diskWriteOps;
          this.diskReadOpsByAi = res.data.diskReadOpsByAi;
          this.diskWriteOpsByAi = res.data.diskWriteOpsByAi;
          this.xaxisDataAWS = res.data.xaxisData;
          if (this.xaxisDataAWS[0] == null) {
            this.xaxisDataAWS = [];
          }
          this.volumeReadWriteOpsOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 读取吞吐量 写入吞吐量
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.disk.line.ReadThroughput"),
                this.$t("alarms.disk.line.WriteThroughput"),
                this.$t("alarms.disk.line.ReadThroughputForecast"),
                this.$t("alarms.disk.line.WriteThroughputForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.disk.line.ReadThroughput"),
                type: "line",
                data: this.diskReadOps,
                itemStyle: {
                  normal: {
                    color: "#c23531",
                    lineStyle: {
                      color: "#c23531"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.disk.line.WriteThroughput"),
                type: "line",
                data: this.diskWriteOps,
                itemStyle: {
                  normal: {
                    color: "#2f4554",
                    lineStyle: {
                      color: "#2f4554"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.disk.line.ReadThroughputForecast"),
                type: "line",
                data: this.diskReadOpsByAi,
                itemStyle: {
                  normal: {
                    color: "#5F9EA0",
                    lineStyle: {
                      color: "#5F9EA0"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.disk.line.WriteThroughputForecast"),
                type: "line",
                data: this.diskWriteOpsByAi,
                itemStyle: {
                  normal: {
                    color: "#DC143C",
                    lineStyle: {
                      color: "#DC143C"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisDataAWS.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartVolumeReadWriteOps.setOption(
            this.volumeReadWriteOpsOption,
            true
          );
        })
        .catch(err => {
          this.chartVolumeReadWriteOps.hideLoading();
        });
    },
    // 读写宽带（字节）
    chartVolumeReadWriteBytesLine: function() {
      this.chartVolumeReadWriteBytes = this.$echarts.init(
        document.getElementById("volumeReadWriteBytes")
      );
      this.chartVolumeReadWriteBytes.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 11,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["DiskReadBytes", "DiskWriteBytes"]
        })
        .then(res => {
          this.chartVolumeReadWriteBytes.hideLoading();
          this.diskReadBytes = res.data.diskReadBytes;
          this.diskWriteBytes = res.data.diskWriteBytes;
          this.diskReadBytesByAi = res.data.diskReadBytesByAi;
          this.diskWriteBytesByAi = res.data.diskWriteBytesByAi;
          this.xaxisDataAWS = res.data.xaxisData;
          if (this.xaxisDataAWS[0] == null) {
            this.xaxisDataAWS = [];
          }
          this.volumeReadWriteBytesOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 读取带宽 写入带宽
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.disk.line.ReadBandwidth"),
                this.$t("alarms.disk.line.WriteBandwidth"),
                this.$t("alarms.disk.line.ReadBandwidthForecast"),
                this.$t("alarms.disk.line.WriteBandwidthForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.disk.line.ReadBandwidth"),
                type: "line",
                data: this.diskReadBytes,
                itemStyle: {
                  normal: {
                    color: "#ccc",
                    lineStyle: {
                      color: "#ccc"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.disk.line.WriteBandwidth"),
                type: "line",
                data: this.diskWriteBytes,
                itemStyle: {
                  normal: {
                    color: "#4671D5",
                    lineStyle: {
                      color: "#4671D5"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.disk.line.ReadBandwidthForecast"),
                type: "line",
                data: this.diskReadBytesByAi,
                itemStyle: {
                  normal: {
                    color: "#B22222",
                    lineStyle: {
                      color: "#B22222"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.disk.line.WriteBandwidthForecast"),
                type: "line",
                data: this.diskWriteBytesByAi,
                itemStyle: {
                  normal: {
                    color: "	#2F4F4F",
                    lineStyle: {
                      color: "	#2F4F4F"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisDataAWS.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartVolumeReadWriteBytes.setOption(
            this.volumeReadWriteBytesOption,
            true
          );
        })
        .catch(err => {
          this.chartVolumeReadWriteBytes.hideLoading();
        });
    },

    /******************************/
    // 点击返回详情页
    ipAddress: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.volumeAwsId = this.$route.query.volumeAwsId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.$router.push({
        path: "/monitor/elasticBlockStoreDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          volumeAwsId: this.volumeAwsId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    }
  }
};
</script>

<style scoped>
.ebs-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}

.ivu-col-span-12 {
  margin-bottom: 20px;
}

.ivu-col-span-6 {
  margin-bottom: 20px;
}

.ebs-top {
  width: 100%;
  height: 53px;
}

.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ebs/ebs_dashboard/EBSForecast.vue